import bugsnagClient from "index"
import Utils from "./utils"

export default class RemoteLogger {
    static initialize() {
        // Initialize the bugsnag app
    }

    static log(errorObj) {
        console.log("Sending error to bugsnag - ", errorObj)
        console.log(errorObj)
        if (!Utils.isNull(bugsnagClient)) {//This is really wierd, erros says notify is called on undefined, although the bugsnagclient is reporting this error on dashboard
            bugsnagClient.notify(errorObj)
        }
    }

    static logStr(errStr) {
        console.log(errStr)
        this.log(new Error(errStr))
    }
}


// WEBPACK FOOTER //
// ./src/common/remoteLogger.js